import { SIZE_50 } from '@/lib/gridElements/size';

import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { MediaViewerKPI } from '@/components/base/Kpi/MediaViewerKpi';

import { videoViewsTotalTimeConfig } from '../videoViewsTotalTime';

export const videoViewsTotalTimeMVConfig = {
    ...videoViewsTotalTimeConfig,
    tooltip: false,
    name: 'kpi.facebook.video_total_time',
    id: 'video_views_total_time',
    size: SIZE_50,
    loader: MediaViewerKpiLoader,
    element: MediaViewerKPI
};
